import { Directive, ElementRef, EventEmitter, Injector, Input, Output } from '@angular/core';
import { UpgradeComponent } from '@angular/upgrade/static';

@Directive({
    selector: 'tt-document-viewer-legacy',
})
export class DocumentViewerLegacyDirective extends UpgradeComponent {
    /**
     * The email to display in the viewer or the file item.
     */
    @Input()
    public ttModel: any = {};

    /**
     * Whether the model is a email or not, overriding the check for 'msg' type.
     *
     * @default 'false'
     */
    @Input()
    public ttIsEmail: 'true' | 'false' = 'false';

    /**
     * Whether to show sent data (sender and sent datetime),
     *
     * @default 'false'
     */
    @Input()
    public ttEmailShowSentData: 'true' | 'false' = 'false';

    /**
     * How to display the reply button on the email viewer.
     *
     * @default 'none'
     */
    @Input()
    public ttEmailReplyView: 'inline' | 'bottom' | 'none' = 'none'; // 'inline' | 'bottom' | 'none'

    /**
     * How to display the attachments on the email viewer.
     *
     * @default 'none'
     */
    @Input()
    public ttEmailAttachmentsView: 'inline' | 'bottom' | 'none' = 'none'; // 'inline' | 'bottom' | 'none'

    /**
     * List of attachments to display on the email viewer.
     */
    @Input()
    public ttEmailAttachments: any[] = [];

    /**
     * Event emitted when an attachment has been clicked.
     */
    @Output()
    public ttEmailAttachmentClick = new EventEmitter<{ attachment: any }>();

    /**
     * Whether to always use the sender fallback (instead of person query as for some shared emails the first sender name is stored, but may not be the correct sender name).
     *
     * @default 'false'
     */
    @Input()
    ttEmailUserSenderFallback: 'true' | 'false' = 'false';

    /**
     * Additional buttons to display in the email viewer.
     */
    @Input()
    ttEmailButtons: any[] = [];

    /**
     * Whether to show the document
     */
    @Input()
    ttShowDocument: 'true' | 'false' = 'false';

    constructor(elementRef: ElementRef, injector: Injector) {
        super('ttDocumentViewer', elementRef, injector);
    }
}
